// extracted by mini-css-extract-plugin
export var addButton = "recipe-list-module--add-button--NIch0";
export var grid = "recipe-list-module--grid--FeIx6";
export var header = "recipe-list-module--header--HYqW6";
export var hero = "recipe-list-module--hero--OExNL";
export var list = "recipe-list-module--list--P0PqD";